import { render } from "./ExternalSourcesPage.vue?vue&type=template&id=68f77e68"
import script from "./ExternalSourcesPage.vue?vue&type=script&lang=js"
export * from "./ExternalSourcesPage.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__